@if (showButton) {
  @if (state) {
    <app-icon name="tick" class="banner-success-icon text-success mr-2" />
    <span class="brandon btn bright flex-shrink-0 d-inline-flex align-items-center" (click)="toggle()"
      >{{ 'ALPINPRODUCT.protectYourself.remove' | alpitranslate }}
      <app-icon name="cross" class="d-none d-sm-inline ml-1"
    /></span>
  } @else {
    <span class="brandon btn d-none d-sm-flex flex-shrink-0 v3 align-items-center" (click)="toggle()"
      >{{ 'ALPINPRODUCT.protectYourself.addProtection' | alpitranslate }} <app-icon name="chevronRight"
    /></span>
    <span class="btn d-flex d-sm-none flex-shrink-0 align-items-center" (click)="toggle()"
      >{{ 'ALPINPRODUCT.protectYourself.add' | alpitranslate }} <app-icon name="chevronRight"
    /></span>
  }
} @else {
  <div class="switch" [class.active]="state" (click)="toggle()">
    <div class="switch-dot"></div>
  </div>
}
